import React, { FunctionComponent, ReactElement } from 'react';
import IProductVariantShort from '../../../../../../common/model/variants/IProductVariantShort';
import Loader from '../../presentation/Loader';
import { Box } from '@material-ui/core';
import VariantSelectorItemContainer from '../variantSelectorItem/VariantSelectorItemContainer';

export interface IVariantList {
  variants: {
    [variantId: string]: IProductVariantShort;
  };
  model: string;
  selectedVariantId: string;
  selectVariantId: (variantId: string) => void;
  detailsSlot?: ReactElement;
}

const VariantList: FunctionComponent<IVariantList> = ({
  variants,
  model,
  selectedVariantId,
  selectVariantId,
  detailsSlot,
}) => {
  if (!variants) {
    return <Loader />;
  }

  return (
    <Box data-test={'variant:list'} width={1}>
      {Object.keys(variants).map(id => (
        <Box
          key={variants[id].carId}
          data-test={`variant:selector:${variants[id].fullName}`}
          data-selected={selectedVariantId.toLowerCase() === id.toLowerCase()}
        >
          <VariantSelectorItemContainer
            modelName={model}
            variantName={variants[id].fullName}
            variantShortName={variants[id].shortName}
            selected={selectedVariantId.toLowerCase() === id.toLowerCase()}
            id={id}
            selectVariantId={selectVariantId}
            detailsSlot={detailsSlot}
          />
        </Box>
      ))}
    </Box>
  );
};

export default VariantList;
